import {getSession} from "./cognito";
import axios from "./instance_py";

const Api = {
    async callProtectedApi(method: string, endpoint: string, options: any = {}) {
        try {
            let token: any = "";
            
            // Add error handling around getSession specifically
            let session: any;
            try {
                session = await getSession();
            } catch (sessionError) {
                token=false;
            }
            
            
            if (session) {
                try {
                    token = session.getIdToken().getJwtToken();
                } catch (tokenError) {
                    token=false;
                }
            }
            
            
            const response = await axios({
                method,
                url: endpoint,
                ...options,
                headers: {
                    ...options?.headers,
                    Authorization: token ? `Bearer ${token}` : undefined
                }
            });
            
            
            return response.data;
        } catch (error) {
            console.error('API call failed:', {
                name: error.name,
                message: error.message,
                stack: error.stack
            });
            throw error;
        }
    }
};
export default Api;